export interface CrosswordResponse {
  grid: CrosswordCell[][];
  acrossClues: Clue[];
  downClues: Clue[];
  title: string;
  uuid: string;
}

export interface CrosswordCell {
  answer?: string;
  number?: number;
}

export interface Clue {
  number: number;
  clue: string;
}


export interface ExploreResponse {
  cards: ExploreCard[];
}

export interface ExploreCard {
  grid: boolean[][];
  title: string;
  uuid: string;
  interests: string[];
  timestamp: number;
  view_count: number;
}

export interface ExploreRequest {
  filter: ExploreFilter;
  page: number; 
}

export enum ExploreFilter {
  PopularWeek = 'popular_week',
  PopularMonth = 'popular_month',
  PopularYear = 'popular_year',
  PopularAllTime = 'popular_all_time',
  Recent = 'recent'
}